// 从 antd App context 拿 message / modal / notification
// 替换静态 message.x / Modal.x 调用的目的是让这些 API 能消费 ConfigProvider 的动态 theme
// 静态 API 拿不到 theme context,会导致 [antd: message] 警告 + 主题不一致
import { App } from 'antd'
import { getErrorMessage } from '../utils'

export const useMessage = () => App.useApp().message
export const useModal = () => App.useApp().modal

// 封装 mutation onError 模板 —
//   onError: (err) => message.error(getErrorMessage(err, 'X失败'))
//   ↓
//   onError: useMutationError('X失败')
// 错误消息格式(`getErrorMessage(err, label)`)统一在这里,后续要加 dev console
// 日志、错误埋点、改成 antd notification 等都只改这一处。
export const useMutationError = (label) => {
  const message = useMessage()
  return (err) => message.error(getErrorMessage(err, label))
}

